import './bootstrap.min';
import './plugins/jquery-ui-timepicker-addon';
import './toastr.min';
import './custom';

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
window.Fancybox = Fancybox;

import.meta.glob([
    '../images/**'
]);

toastr.options = {
    "closeButton": true,
    "debug": false,
    "newestOnTop": false,
    "progressBar": true,
    //"positionClass": "toast-bottom-center",
    "preventDuplicates": false,
    "onclick": null,
    "showDuration": "300",
    "hideDuration": "1000",
    "timeOut": "9000",
    "extendedTimeOut": "1000",
    "showEasing": "swing",
    "hideEasing": "linear",
    "showMethod": "fadeIn",
    "hideMethod": "fadeOut"
}

document.addEventListener('livewire:init', () => {
    Livewire.on('toastr', (event) => {
        alertMsg(event.detail.msg, event.detail.type);
    });
});

function alertMsg(msg, type) {
    toastr[type](msg);
}

document.addEventListener('DOMContentLoaded', () => {
    $('[data-toggle="tooltip"]').tooltip({
        trigger: 'click',
    });

    if(!$('#self_guide_popup').length){
        $('#sgv-play-btn').hide();
    }

    Fancybox.bind("[data-fancybox]:not([data-fancybox^='order-gallery-'])", {
        Carousel: {
            Toolbar: {
                display: {
                    left: ["counter"],
                    middle: [
                        "zoomIn",
                        "zoomOut",
                        "toggle1to1",
                        "rotateCCW",
                        "rotateCW",
                        "flipX",
                        "flipY",
                    ],
                    right: ["autoplay", "thumbs", "fullscreen", "close"],
                },
            },
        },
    });
});

/*
// Global unsaved changes flag
window.__unsavedChanges = false;

// Detect any input, select, textarea change
document.addEventListener('input', function () {
    window.__unsavedChanges = true;
});

// Detect Livewire model changes (optional, but useful)
document.addEventListener('livewire:update', function () {
    window.__unsavedChanges = true;
});

// Show browser confirmation when leaving the page
window.addEventListener('beforeunload', function (e) {
    if (window.__unsavedChanges) {
        e.preventDefault();
        e.returnValue = '';
    }
});

// Call this after save to reset dirty state
window.markPageAsSaved = function () {
    window.__unsavedChanges = false;
};
*/